export default "__VITE_ASSET__BD4UhlWk__"